const signalR = require("@microsoft/signalr");

class SignalRConnection {
  initialize(hub, signalUrl) {
    if (!this._connection) {
      this._connection = new signalR.HubConnectionBuilder()
        .withUrl(signalUrl + `/` + hub)
        .configureLogging(signalR.LogLevel.Information)
        .build();
    }
  }
  async start(callback) {
    try {
      await this._connection.start();
      callback();
    } catch (err) {
      console.log(err);
    }
  }
  async stop() {
    try {
      await this._connection.stop();
    } catch (err) {
      console.log(err);
    }
  }
  invoke(method, ...params) {
    this._connection.invoke(method, ...params);
  }
  on(event, callback) {
    this._connection.on(event, result => {
      callback(result);
    });
  }
}

export default SignalRConnection;
